import axios from 'axios';
import s from './s';
import {runInAction} from 'mobx';
import {ProductState} from './i';
import {imageUploadStore} from './components/image-upload/image-upload.store';

window.dataLayer = window.dataLayer || [];

const req = (_url: string, o: any): Promise<any> => {
    return axios
        .post(_url, o)
        .then(response => {
            return response.data as any;
        })
        .catch(err => {
            console.error(err);
            return err;
        });
};

export const redeemCode = async (): Promise<void> => {
    const result: ProductAPIResult = await req('/api/redeem', getProductPackage());
    runInAction(() => {
        // approved ria
        window.location.href = window.location.href;
        window.location.reload();
    });
};

export const pricing = async (): Promise<void> => {
    const result: ProductAPIResult = await req('/api/pricing', getProductPackage());
    runInAction(() => {
        // approved ria
        s.ui.price = result.result_decimal;
        s.ui.price_discount = result.result_decimal_discount;
    });
};

export const statevent = async (s: IStatEvent): Promise<void> => {
    // axios.post('/api/info/event', s);
};

export const add_to_cart = async (buyNow = false): Promise<void> => {
    // check image upload
    // console.log(s.pcs.override_d1_img);
    if (s.ps.override_d1_img) {
        await imageUploadStore.uploadImage();
    }

    const result: ProductAPIResult = await req('/api/atc', getProductPackage());

    runInAction(() => {
        // approved ria
        s.ps.atc_error = '';
        if (result.success === 1) {
            window.location.href = buyNow ? `${result.redirect_url}?buyNow=1` : result.redirect_url;
        } else if (result.success === 0) {
            s.ps.atc_error = result.error;
        }
    });
};

export const prod_cat = async (LinkToProductID: number): Promise<any> => {
    const v = getProductPackage();
    v.ProductID = LinkToProductID;
    const result: ProductAPIResult = await req('/api/prod_cat', v);
    console.log(result);
    return result.msg;
};

const getProductPackage = (): ProductUpdateFromClient => {
    return {
        ProductID: s.prod.ProductID,
        StoreID: s.si.StoreID,
        ps: s.ps,
        pcs_json: JSON.stringify(s.pcs),
    };
};

interface ProductUpdateFromClient {
    ProductID: number;
    StoreID: number;
    ps: ProductState;
    pcs_json: string;
}

interface ProductAPIResult {
    success: number;
    error: string;
    msg: string;
    result_decimal: number;
    result_decimal_discount: number;
    result_int: number;
    item_id: string;
    sku: string;
    redirect_url: string;
}

interface IStatEvent {
    d1: string;
    d2: string;
    d3: string;
}
